import apiClientService from '@/repositories';
import loadScript from '@/utils/loadScript';

const CLIENT_ID = '338732364255-v37bkjjspf56inbcv7got9ekl6r3jnui.apps.googleusercontent.com';
const SCOPES = [
  'https://www.googleapis.com/auth/userinfo.email',
	'https://www.googleapis.com/auth/calendar.freebusy',
	'https://www.googleapis.com/auth/calendar.events.owned',
	'https://www.googleapis.com/auth/calendar.calendarlist.readonly',
];

// https://developers.google.com/identity/oauth2/web/guides/migration-to-gis#implicit-flow_3
async function syncCalendars() {
	await loadScript('https://accounts.google.com/gsi/client');

	return new Promise((resolve, reject) => {
		// @ts-ignore
		const client = google.accounts.oauth2.initCodeClient({
			client_id: CLIENT_ID,
			scope: SCOPES.join(' '),
			ux_mode: 'popup',
			callback: (response: { code: string }) =>
				apiClientService.google.consent(response.code).then(resolve).catch(reject),
			error_callback: reject,
		});

		client.requestCode();
	});
}

export default { syncCalendars };
